import React, { createContext, useContext, useState } from 'react';

export interface UserGroup {
  id: number;
  name: string;
  isAdmin: boolean;
  starred: boolean;
  deviceCount: number;
}

export interface UserDevice {
  id: number;
  name: string;
  shareKey: string;
  graphColor: string;
  isVirtual: boolean;
  isAutoGenerated: boolean;
  pushNotificationDailyOverviewEnabled: boolean;
  pushNotificationNoDataEnabled: boolean;
  pushNotificationGroupWinner: boolean;
}

export enum Theme {
  Dark = 'dark',
  Light = 'light',
  Auto = 'auto',
}

export interface User {
  id: number;
  name: string;
  email: string;
  groups: UserGroup[];
  devices: UserDevice[];
  timezone: string;
  isPowerUser: boolean;
  moduleId: string;
  theme: Theme;
  avatar: string;
}

interface Props {
  user?: User | null;
  children: React.ReactNode;
}

export type UserContextType = {
  user: User | null;
  setUser: (user: User | null) => void;
};

const UserContext = createContext<UserContextType>({
  user: null,
  setUser: () => console.warn('no user provider'),
});

export function useUserObject(): UserContextType {
  return useContext(UserContext);
}

export function UserProvider({ children }: Props): JSX.Element {
  const [user, setUser] = useState<User | null>(null);

  return <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>;
}
